import { Directive, ElementRef,  OnInit } from '@angular/core';

@Directive({
  selector: '[passportNumber]'
})
export class PassportNumberDirective implements OnInit{ 
  
  constructor(private el: ElementRef) {
  }

  ngOnInit(): void {
    const elem = this.el.nativeElement;
    var regExAlphaNumeric = new RegExp("^[a-zA-Z0-9 ]+$");
    
    elem.addEventListener('keydown', (evt) =>!regExAlphaNumeric.test(evt.key) && evt.preventDefault());

    elem.addEventListener("paste", (event) => {
      event.preventDefault();

      let paste = (event.clipboardData).getData('text');
      paste = paste.replace(/[^a-zA-Z0-9]/g, '');
      this.el.nativeElement.value = paste;
    });
  }

}